import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../App.scss';
import {login} from "../../../Store/Actions/AuthActions";

class FreeCoinItem extends React.Component{
    constructor(props){
        super(props)
        this.state={
            prp:null,
            animation:null,
            seconds:0,
            remainingTime:''
        }
    }
    intvl=()=>{
        setInterval(() => {
                const timeString = new Date(this.state.seconds * 1000).toISOString().substr(11, 8);
                this.setState({
                    remainingTime: timeString,
                    seconds: this.state.seconds - 1
                })
            }
            , 1000);
    }
    checkInterval=(sec)=>{
            this.setState({
                seconds: sec
            },()=>{
                this.intvl()
            })
    }
    componentDidMount() {
        const sec = this.props.data.remainingTime
        if (sec != '0')
            this.checkInterval(sec)
    }
    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.data.remainingTime != 0 && this.state.seconds==0){
            this.checkInterval( this.props.data.remainingTime)
        }

    }
        render() {
        const {text,image,backgroundImage,hasAnimation,id}=this.props.data
        const {remainingTime}=this.state
        return(
            <Grid item container sm={12} className='free-coin-section'>
                    <Grid className='free-coin-section-item'>
                        <img src={backgroundImage} className='free-coin-section-item-background-image' alt=""/>
                        <img src={image}
                             className={"free-coin-section-item-image " + (hasAnimation ? 'free-coin-image-animation' : '')}
                             alt=""/>
                        {
                            id==='dailyGift' &&
                            <p style={{
                                position:'absolute',
                                fontSize:'157%',
                                bottom:'0',
                                color:'#000000'
                            }}>
                                {remainingTime}
                            </p>
                        }

                        <h5 className='free-coin-section-item-text'>
                            {text}
                        </h5>
                    </Grid>
            </Grid>
            )
    }
}
export default FreeCoinItem